<div class="notification-bar-component d-flex align-items-center" [ngClass]="notificationStyle">
  <mat-icon class="notification-icon" svgIcon="{{ notificationIcon }}"></mat-icon>
  <div class="flex-fill">
    <p class="m-0">{{ message }}</p>
  </div>
  <div>
    <ng-template #defaultTemplate>
      <span class="btn-close pointer" (click)="handleOpenExternalLink()" *ngIf="openExternalLink">
        <span>{{ labelExternalLink }}</span>
      </span>
      <span *ngIf="showBtnClose" class="btn-close pointer" (click)="handleCloseAction()">
        <span>Fechar</span>
      </span>
    </ng-template>
    <ng-container [ngTemplateOutlet]="defaultTemplate"></ng-container>
  </div>
</div>
